/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../../__generated__/zeus/types';

import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
/** Current customer-facing status of a marketplace listing. */
export type MarketplaceListingState =
  /** The home is expected to become available for purchase soon. */
  | 'AVAILABLE_SOON'
  /** The home is under contract with a buyer. */
  | 'IN_CONTRACT'
  /** The home is currently offered for purchase. */
  | 'ON_THE_MARKET'
  /** The home has recently sold. */
  | 'RECENTLY_SOLD'
  /** The home’s current marketplace status could not be determined. */
  | 'UNKNOWN';

/** Customer sentiment about a home tour. */
export type TourFeedbackSentiment =
  /** Customer had a negative experience. */
  | 'NEGATIVE'
  /** Customer had a neutral experience. */
  | 'NEUTRAL'
  /** Customer had a positive experience. */
  | 'POSITIVE'
  /** Feedback has no assigned sentiment. */
  | 'UNSPECIFIED';

export type HubBuyerListingFragment = { addressId: Types.Scalars['UUID']['output'], bathrooms: Types.Scalars['Float']['output'] | null, bedrooms: Types.Scalars['SafeInt']['output'] | null, fullAddress: Types.Scalars['String']['output'] | null, listPriceCents: Types.Scalars['SafeInt']['output'] | null, listingState: Types.MarketplaceListingState, photoUrls: Array<Types.Scalars['URL']['output']>, slug: Types.Scalars['String']['output'] | null, street: Types.Scalars['String']['output'] | null, totalLivingSquareFootage: Types.Scalars['SafeInt']['output'] | null };

export type HubBuyerListingsAndToursQueryVariables = Exact<{ [key: string]: never; }>;


export type HubBuyerListingsAndToursQuery = { customerAccount: { buyer: { favorites: Array<{ listing: { addressId: Types.Scalars['UUID']['output'], bathrooms: Types.Scalars['Float']['output'] | null, bedrooms: Types.Scalars['SafeInt']['output'] | null, fullAddress: Types.Scalars['String']['output'] | null, listPriceCents: Types.Scalars['SafeInt']['output'] | null, listingState: Types.MarketplaceListingState, photoUrls: Array<Types.Scalars['URL']['output']>, slug: Types.Scalars['String']['output'] | null, street: Types.Scalars['String']['output'] | null, totalLivingSquareFootage: Types.Scalars['SafeInt']['output'] | null } | null }>, tours: Array<{ id: Types.Scalars['ID']['output'], addressId: Types.Scalars['UUID']['output'] | null, endTime: Types.Scalars['DateTime']['output'] | null, listingId: Types.Scalars['NonEmptyString']['output'] | null, readableAddress: Types.Scalars['NonEmptyString']['output'] | null, scheduledFor: Types.Scalars['DateTime']['output'] | null, timezone: Types.Scalars['TimeZone']['output'] | null, usingTrippy: Types.Scalars['Boolean']['output'] | null, listing: { addressId: Types.Scalars['UUID']['output'], bathrooms: Types.Scalars['Float']['output'] | null, bedrooms: Types.Scalars['SafeInt']['output'] | null, fullAddress: Types.Scalars['String']['output'] | null, listPriceCents: Types.Scalars['SafeInt']['output'] | null, listingState: Types.MarketplaceListingState, photoUrls: Array<Types.Scalars['URL']['output']>, slug: Types.Scalars['String']['output'] | null, street: Types.Scalars['String']['output'] | null, totalLivingSquareFootage: Types.Scalars['SafeInt']['output'] | null } | null }> } } };

export type HubBuyerTourFeedbacksQueryVariables = Exact<{ [key: string]: never; }>;


export type HubBuyerTourFeedbacksQuery = { customerAccount: { buyer: { tourFeedbacks: Array<{ id: Types.Scalars['ID']['output'], sentiment: Types.TourFeedbackSentiment, viewingAppointmentId: Types.Scalars['NonEmptyString']['output'] | null }> } } };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const HubBuyerListingFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment HubBuyerListing on MarketplaceListing {
  addressId
  bathrooms
  bedrooms
  fullAddress
  listPriceCents
  listingState
  photoUrls(first: 1)
  slug
  street
  totalLivingSquareFootage
}
    `, {"fragmentName":"HubBuyerListing"}) as unknown as TypedDocumentString<HubBuyerListingFragment, unknown>;
export const HubBuyerListingsAndToursDocument = /*#__PURE__*/ new TypedDocumentString(`
    query HubBuyerListingsAndTours {
  customerAccount {
    buyer {
      favorites {
        listing {
          ...HubBuyerListing
        }
      }
      tours {
        id
        addressId
        endTime
        listingId
        readableAddress
        scheduledFor
        timezone
        usingTrippy
        listing {
          ...HubBuyerListing
        }
      }
    }
  }
}
    fragment HubBuyerListing on MarketplaceListing {
  addressId
  bathrooms
  bedrooms
  fullAddress
  listPriceCents
  listingState
  photoUrls(first: 1)
  slug
  street
  totalLivingSquareFootage
}`) as unknown as TypedDocumentString<HubBuyerListingsAndToursQuery, HubBuyerListingsAndToursQueryVariables>;
export const HubBuyerTourFeedbacksDocument = /*#__PURE__*/ new TypedDocumentString(`
    query HubBuyerTourFeedbacks {
  customerAccount {
    buyer {
      tourFeedbacks(limit: 50) {
        id
        sentiment
        viewingAppointmentId
      }
    }
  }
}
    `) as unknown as TypedDocumentString<HubBuyerTourFeedbacksQuery, HubBuyerTourFeedbacksQueryVariables>;